import {
  HirerPromoCodesBanner,
  type TrackingEvent,
} from '@seek/hirer-promo-codes-banner';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { showPromoCodePageIds } from 'src/app/constants/pageUid';
import getTrackingAdapter from 'src/app/dataAnalytics';
import type AppState from 'src/types/appState';

export const PromoCodeBanner = ({ pageId }: { pageId?: string }) => {
  const onTrackingCallback = useCallback((eventData: TrackingEvent) => {
    getTrackingAdapter.sendLinkEvent(eventData);
  }, []);

  const { productIds } = useSelector((state: AppState) => ({
    productIds: state.session.productSet?.items
      .map((item) => item?.id)
      .flatMap((id) => id || []),
  }));

  return pageId && showPromoCodePageIds.includes(pageId) ? (
    <HirerPromoCodesBanner
      onTrackingCallback={onTrackingCallback}
      productIds={productIds}
    />
  ) : null;
};
